import Vue from 'vue';
import VeeValidate from 'vee-validate';
import Axios from 'axios';
import router from '@/router/router';
import store from '@/store/store';
import vuetify from '@/plugins/vuetify';
import SentryConfig from '@/plugins/sentry';
import App from '@/App.vue';
import WebFontLoader from 'webfontloader';
import apexcharts from 'apexcharts';
import VueApexCharts from 'vue-apexcharts';

import TopBar from '@/views/LayoutElement/top-bar';
import SideNavigation from '@/views/LayoutElement/side-navigation';
import ResetFilters from '@/views/LayoutElement/reset-filters';
import Statistics from '@/views/Statistics/statistics';
import DataTable from '@/views/DataTable/data-table';

import '@/scss/base/_fonts.scss';
import '@/scss/components/_buttons.scss';
import '@fortawesome/fontawesome-free/scss/fontawesome.scss';
import '@fortawesome/fontawesome-free/scss/solid.scss';
import '@fortawesome/fontawesome-free/scss/brands.scss';
import '@fortawesome/fontawesome-free/scss/regular.scss';

SentryConfig.init(window.settings.environment, window.settings.sentryUrl);

Vue.config.productionTip = false;

new Vue({
    router,
    store,
    vuetify,
    VeeValidate,
    Axios,
    apexcharts,
    VueApexCharts,
    TopBar,
    ResetFilters,
    SideNavigation,
    Statistics,
    DataTable,

    data: {
        settings: {}
    },

    created() {
        this.settings = window.settings;

        WebFontLoader.load({
            google: {
                families: ['Source Sans Pro:400,700']
            },
            custom: {
                families: ['SingleSleeve']
            }
        });
    },

    render: h => h(App)
}).$mount('#app');
